import React from 'react';

const Error = () => {
    return (
        <>
        404
        </>
    )
}
export default Error